var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16ZM9.5 5C9.5 4.44772 9.05229 4 8.5 4C7.94772 4 7.5 4.44772 7.5 5V5.5C7.5 6.05228 7.94772 6.5 8.5 6.5C9.05229 6.5 9.5 6.05228 9.5 5.5V5ZM9.5 8.5C9.5 7.94772 9.05229 7.5 8.5 7.5C7.94772 7.5 7.5 7.94772 7.5 8.5V12C7.5 12.5523 7.94772 13 8.5 13C9.05229 13 9.5 12.5523 9.5 12V8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d7e39488ac684f6dad3838e6035657d7.svg";
export { ForwardRef as ReactComponent };